import { AgGridReact } from "ag-grid-react";
import React, { Fragment } from "react";
import { useState, useEffect } from "react";
import {
  allplayerlist,
  playerdelete,
  similarmergeplayer,
  schoollist,
} from "../../../../services/superadmin";
import { funderlist } from "../../../../services/master";
import { Link, useNavigate, useParams } from "react-router-dom";
import { schoolplayerlist } from "../../../../services/schoolhead";
import {
  cityplayerlist,
  schooldetailcityreg,
} from "../../../../services/cityregionaladmin";
import { useMemo } from "react";
import moment from "moment";
import dotracking from "../../../trackinglogs";
import trackobj from "../../../trackingpages.json";
import Swal from "sweetalert2";
import Select from "react-select";
import { toast } from "react-toastify";
import { Modal, Table } from "react-bootstrap";
import { coachplayerlist } from "../../../../services/coach";
import { schoolwiseplayerlist } from "../../../../services/common";

export const AllPlayers = () => {
  const [filterProduct, setFilterProduct] = useState([]);
  const { id } = useParams();

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [perPage] = useState(100);

  const [fUsername, setFUsername] = useState("");
  const [fFullName, setFFullName] = useState("");
  const [fGender, setFGender] = useState("");
  const [fDobYear, setFDobYear] = useState("");
  const [fMobile, setFMobile] = useState("");
  const [fEmail, setFEmail] = useState("");
  const [fSchoolIds, setFSchoolIds] = useState([]);
  const [schoolListData, setSchoolListData] = useState([]);
  const [fFunderIds, setFFunderIds] = useState([]);
  const [funderListData, setFunderListData] = useState([]);

  const sorting = useMemo(() => {
    return ["asc", "desc"];
  }, []);

  const columnDefs = [
    {
      headerName: "Action",
      width: 100,
      field: "user_id",
      sortable: true,
      resizable: true,
      filter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <input
              type="checkbox"
              checked={params.data.check}
              onChange={(e) => mergecheck(e, params.value)}
            />
          </div>
        );
      },
    },
    {
      headerName: "Mapped",
      width: 150,
      field: "mappedornot",
      sortable: true,
      resizable: true,
      filter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Username",
      width: 150,
      field: "username",
      sortable: true,
      resizable: true,
      filter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Full Name",
      width: 170,
      field: "first_name",
      sortable: true,
      resizable: true,
      filter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Gender",
      width: 150,
      field: "gender",
      sortable: true,
      resizable: true,
      filter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "D.O.B",
      width: 160,
      field: "date_of_birth",
      sortable: true,
      resizable: true,
      filter: false,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return moment(params.value).format("DD-MM-yyyy");
        }
      },
    },
    {
      headerName: "Mobile",
      width: 160,
      field: "mobile_no",
      sortable: true,
      resizable: true,
      filter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Email",
      width: 160,
      field: "email_id",
      sortable: true,
      resizable: true,
      filter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "School",
      width: 220,
      field: "school_name",
      sortable: true,
      resizable: true,
      filter: false,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Funder",
      width: 150,
      field: "school_funder",
      sortable: true,
      resizable: true,
      filter: false,
      cellStyle: { textAlign: "left" },
    },
    // {
    //   headerName: "Registered Date",
    //   width: 150,
    //   field: "registerdate",
    //   sortable: true,
    //   resizable: true,
    //   filter: true,
    //   floatingFilter: true,
    //   cellStyle: { textAlign: "left" },
    //   cellRenderer: function (params) {
    //     if (params.value !== null) {
    //       return moment(params.value).format("DD-MM-yyyy")
    //     }
    //   },
    // },
    {
      headerName: "Actions",
      width: 100,
      field: "user_id",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => viewlist(params.value, params.data)}
              title="View Player"
              className="btn-sm btn-secondary me-2"
            >
              <i className="fa fa-eye fa-lg"></i>
            </a>
            {localStorage.getItem("Subrole") === "1" && (
              <a
                onClick={() => deletelist(params.value, params.data)}
                title="Delete Player"
                className="btn-sm btn-danger"
              >
                <i className="fa fa-trash fa-lg"></i>
              </a>
            )}
          </div>
        );
      },
    },
  ];

  const ShcolumnDefs = [
    // {
    //   headerName: "Mapped",
    //   width: 150,
    //   field: "mappedornot",
    //   sortable: true,
    //   resizable: true,
    //   filter: true,
    //   floatingFilter: true,
    //   cellStyle: { textAlign: "left" },
    // },
    {
      headerName: "Actions",
      width: 100,
      field: "user_id",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => viewlist(params.value, params.data)}
              title="View Player"
              className="btn-sm btn-secondary"
            >
              <i className="fa fa-eye fa-lg"></i>
            </a>
          </div>
        );
      },
    },
    {
      headerName: "UID",
      width: 150,
      field: "username",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Full Name",
      width: 170,
      field: "first_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Gender",
      width: 150,
      field: "gender",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "D.O.B",
      width: 160,
      field: "date_of_birth",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return moment(params.value).format("DD-MM-yyyy");
        }
      },
    },
    {
      headerName: "Mobile",
      width: 160,
      field: "mobile_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Email",
      width: 160,
      field: "email_id",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Team",
      width: 160,
      field: "school_team_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Date of Joining",
      width: 160,
      field: "date_of_join",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return moment(params.value).format("DD-MM-yyyy");
        }
      },
    },
    {
      headerName: "Active/Passive",
      width: 160,
      field: "active_or_passive_status",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];


  const FcolumnDefs = [
    // {
    //   headerName: "Mapped",
    //   width: 150,
    //   field: "mappedornot",
    //   sortable: true,
    //   resizable: true,
    //   filter: true,
    //   floatingFilter: true,
    //   cellStyle: { textAlign: "left" },
    // },
    {
      headerName: "Actions",
      width: 100,
      field: "student_user_id",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() => viewlist(params.value, params.data)}
              title="View Player"
              className="btn-sm btn-secondary"
            >
              <i className="fa fa-eye fa-lg"></i>
            </a>
          </div>
        );
      },
    },
    {
      headerName: "UID",
      width: 150,
      field: "username",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Full Name",
      width: 170,
      field: "first_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },

    {
      headerName: "Gender",
      width: 150,
      field: "gender",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "D.O.B",
      width: 160,
      field: "date_of_birth",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return moment(params.value).format("DD-MM-yyyy");
        }
      },
    },
    {
      headerName: "Mobile",
      width: 160,
      field: "mobile_no",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Email",
      width: 160,
      field: "email_id",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  
    {
      headerName: "Date of Joining",
      width: 160,
      field: "date_of_join",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        if (params.value !== null) {
          return moment(params.value).format("DD-MM-yyyy");
        }
      },
    },
    {
      headerName: "Active/Passive",
      width: 160,
      field: "active_or_passive_status",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];
  function rowDoubleClicked(e) {
    dotracking(
      "row double clicked in all players list for player " +
        e.data.first_name +
        " (" +
        e.data.username +
        " - " +
        e.data.user_id +
        ") $$ " +
        trackobj.playerdetheading
    );
    if (localStorage.getItem("Role") === "1") {
      navigate("/superadmin/viewplayer/" + e.data.user_id);
    } else if (localStorage.getItem("Role") === "3") {
      navigate("/cityregional/viewplayer/" + e.data.user_id);
    } else if (localStorage.getItem("Role") === "4") {
      navigate("/schoolhead/viewplayer/" + e.data.user_id);
    }
  }

  function deletelist(did, ddata) {
    Swal.fire({
      text: "Are you sure want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "red",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        dotracking(
          "delete icon in all player list for " +
            ddata.first_name +
            " (" +
            ddata.username +
            " - " +
            +did +
            ") $$ " +
            trackobj.playerlistheading
        );
        const temp = new FormData();
        temp.append("user_id", did);
        playerdelete(temp).then((response) => {
          if (response.status === true) {
            toast.success(response.message);
          }
        });
      }
    });
  }
  const navigate = useNavigate();
  function viewlist(eid, edata) {
    dotracking(
      "view icon in all players list for player " +
        edata.first_name +
        " (" +
        edata.username +
        " - " +
        eid +
        ") $$ " +
        trackobj.playerdetheading
    );
    const url = window.location.href;
    const head = url.split("/#/");
    if (localStorage.getItem("Role") === "1") {
      window.open(`${head[0]}/#/superadmin/viewplayer/` + eid, "_blank");
    } else if (localStorage.getItem("Role") === "3") {
      if (urllink === "listplayers") {
        localStorage.setItem("list", 1);
      } else if (urllink === "funderlistplayers") {
        localStorage.setItem("list", 2);
      }
      window.open(`${head[0]}/#/cityregional/viewplayer/` + eid, "_blank");
    } else if (localStorage.getItem("Role") === "4") {
      window.open(`${head[0]}/#/schoolhead/viewplayer/` + eid, "_blank");
    } else if (localStorage.getItem("Role") === "7") {
      window.open(`${head[0]}/#/coach/viewplayer/` + eid, "_blank");
    } else if (localStorage.getItem("Role") === "8") {
      window.open(`${head[0]}/#/funder/viewplayer/` + eid, "_blank");
    }
  }

  const [mdata, setMData] = useState([]);
  const [mshow, setMShow] = useState(false);
  const [fshow, setFShow] = useState(false);

  function mergecheck(e, uid) {
    if (filterProduct.length !== 0) {
      for (let i = 0; i < filterProduct.length; i++) {
        if (filterProduct[i].user_id === uid) {
          if (e.target.checked === true) {
            if (mdata.length < 2) {
              filterProduct[i].check = e.target.checked;
            } else {
              toast.error("Cannot merge more than 2 players");
            }
          } else {
            filterProduct[i].check = e.target.checked;
          }
          setFilterProduct([...filterProduct]);
          const totcnt = filterProduct.filter((item) => item.check == true);
          setMData(totcnt);
          break;
        }
      }
    }
  }
  const [errorMsg, setErrorMsg] = useState("");

  function mergedprofiles(e) {
    e.preventDefault();
    setErrorMsg([]);

    if (muname !== "") {
      setLoading(true);
      const temp = new FormData();
      temp.append("main_user_id", muid);
      temp.append("duplicate_user_ids", mduid);
      temp.append("email_id", memail);
      temp.append("mobile_no", mmob);
      temp.append("first_name", mfname);
      temp.append("date_of_birth", mdob);
      temp.append("gender", mgender);
      temp.append("class", mcls);
      temp.append("section", msec);
      temp.append("username", muname);
      dotracking(
        "merge button in all player list for " +
          muid +
          " and " +
          mduid +
          " $$ " +
          trackobj.playerlistheading
      );

      similarmergeplayer(temp).then((response) => {
        if (response.status === true) {
          setLoading(false);
          setFShow(false);
          setMShow(false);
          listall(1);
          toast.success(response.message);
        } else {
          setLoading(false);
          toast.error(response.message);
        }
      });
    } else {
      setErrorMsg("Please select Username (UID) of Main Player");
    }
  }

  const [muname, setMUName] = useState("");
  const [muid, setMUID] = useState("");
  const [mduid, setMDUID] = useState("");
  function mradiouser(ume) {
    if (mdata.length !== 0) {
      for (let i = 0; i < mdata.length; i++) {
        if (mdata[i].user_id === ume) {
          setMUName(mdata[i].username);
          setMUID(mdata[i].user_id);
          setMFName(mdata[i].first_name);
          setMGender(mdata[i].gender);
          setMDOB(mdata[i].date_of_birth);
          setMMob(mdata[i].mobile_no);
          setMEmail(mdata[i].email_id);
          setMSch(mdata[i].school_id);
          setMClass(mdata[i].class_id);
          setMClassName(mdata[i].class_name);
          setMSection(mdata[i].section);

          mdata[i].radiouser = true;
          setMData([...mdata]);
        } else {
          if (mdata[i].check === true) {
            setMDUID(mdata[i].user_id);
          }
          mdata[i].radiouser = false;
          mdata[i].radioname = false;
          mdata[i].radiogender = false;
          mdata[i].radiodob = false;
          mdata[i].radiomob = false;
          mdata[i].radioemail = false;
          mdata[i].radiocls = false;
          mdata[i].radiosch = false;
          mdata[i].radiosec = false;

          setMData([...mdata]);
        }
      }
    }
  }

  const [mfname, setMFName] = useState("");

  function mradioname(index, ume) {
    if (muname !== "") {
      mdata[index].radioname = !ume;
      setMData([...mdata]);
      if (mdata[index].radioname === true) {
        setMFName(mdata[index].first_name);
      } else {
        for (let i = 0; i < mdata.length; i++) {
          if (mdata[i].check === true) {
            if (i !== index) {
              mdata[i].radioname = true;
              setMData([...mdata]);
              setMFName(mdata[i].first_name);
            }
          }
        }
      }
    } else {
      setErrorMsg("Please select Username (UID) of Main Player");
    }
  }

  const [mgender, setMGender] = useState("");
  function mradiogender(index, ume) {
    if (muname !== "") {
      mdata[index].radiogender = !ume;
      setMData([...mdata]);
      if (mdata[index].radiogender === true) {
        setMGender(mdata[index].gender);
      } else {
        for (let i = 0; i < mdata.length; i++) {
          if (mdata[i].check === true) {
            if (i !== index) {
              mdata[i].radiogender = true;
              setMData([...mdata]);
              setMGender(mdata[i].gender);
            }
          }
        }
      }
    } else {
      setErrorMsg("Please select Username (UID) of Main Player");
    }
  }

  const [mdob, setMDOB] = useState("");
  function mradiodob(index, ume) {
    if (muname !== "") {
      mdata[index].radiodob = !ume;
      setMData([...mdata]);
      if (mdata[index].radiodob === true) {
        setMDOB(mdata[index].date_of_birth);
      } else {
        for (let i = 0; i < mdata.length; i++) {
          if (mdata[i].check === true) {
            if (i !== index) {
              mdata[i].radiodob = true;
              setMData([...mdata]);
              setMDOB(mdata[i].date_of_birth);
            }
          }
        }
      }
    } else {
      setErrorMsg("Please select Username (UID) of Main Player");
    }
  }

  const [mmob, setMMob] = useState("");
  function mradiomob(index, ume) {
    if (muname !== "") {
      mdata[index].radiomob = !ume;
      setMData([...mdata]);
      if (mdata[index].radiomob === true) {
        setMMob(mdata[index].mobile_no);
      } else {
        for (let i = 0; i < mdata.length; i++) {
          if (mdata[i].check === true) {
            if (i !== index) {
              mdata[i].radiomob = true;
              setMData([...mdata]);
              setMMob(mdata[i].mobile_no);
            }
          }
        }
      }
    } else {
      setErrorMsg("Please select Username (UID) of Main Player");
    }
  }

  const [memail, setMEmail] = useState("");
  function mradioemail(index, ume) {
    if (muname !== "") {
      mdata[index].radioemail = !ume;
      setMData([...mdata]);
      if (mdata[index].radioemail === true) {
        setMEmail(mdata[index].email_id);
      } else {
        for (let i = 0; i < mdata.length; i++) {
          if (mdata[i].check === true) {
            if (i !== index) {
              mdata[i].radioemail = true;
              setMData([...mdata]);
              setMEmail(mdata[i].email_id);
            }
          }
        }
      }
    } else {
      setErrorMsg("Please select Username (UID) of Main Player");
    }
  }

  const [msch, setMSch] = useState("");
  function mradiosch(index, ume) {
    if (muname !== "") {
      mdata[index].radiosch = !ume;
      setMData([...mdata]);
      if (mdata[index].radiosch === true) {
        setMSch(mdata[index].school_id);
      } else {
        for (let i = 0; i < mdata.length; i++) {
          if (mdata[i].check === true) {
            if (i !== index) {
              mdata[i].radiosch = true;
              setMData([...mdata]);
              setMSch(mdata[i].school_id);
            }
          }
        }
      }
    } else {
      setErrorMsg("Please select Username (UID) of Main Player");
    }
  }

  const [mcls, setMClass] = useState("");
  const [mclsname, setMClassName] = useState("");

  function mradioclass(index, ume) {
    if (muname !== "") {
      mdata[index].radiocls = !ume;
      setMData([...mdata]);
      if (mdata[index].radiocls === true) {
        setMClass(mdata[index].class_id);
        setMClassName(mdata[index].class_name);
      } else {
        for (let i = 0; i < mdata.length; i++) {
          if (mdata[i].check === true) {
            if (i !== index) {
              mdata[i].radiocls = true;
              setMData([...mdata]);
              setMClass(mdata[i].class_id);
              setMClassName(mdata[index].class_name);
            }
          }
        }
      }
    } else {
      setErrorMsg("Please select Username (UID) of Main Player");
    }
  }

  const [msec, setMSection] = useState("");
  function mradiosection(index, ume) {
    if (muname !== "") {
      mdata[index].radiosec = !ume;
      setMData([...mdata]);
      if (mdata[index].radiosec === true) {
        setMSection(mdata[index].section);
      } else {
        for (let i = 0; i < mdata.length; i++) {
          if (mdata[i].check === true) {
            if (i !== index) {
              mdata[i].radiosec = true;
              setMData([...mdata]);
              setMSection(mdata[i].section);
            }
          }
        }
      }
    } else {
      setErrorMsg("Please select Username (UID) of Main Player");
    }
  }

  function getFilters() {
    return {
      username: fUsername,
      full_name: fFullName,
      gender: fGender,
      dob_year: fDobYear,
      mobile: fMobile,
      email: fEmail,
      school_ids: fSchoolIds.map((s) => s.value).join(","),
      school_funder: fFunderIds.map((f) => f.label).join(","),
    };
  }

  function listall(page, filters) {
    setLoading(true);
    allplayerlist(1, 6, page, perPage, filters || getFilters()).then((response) => {
      if (response !== undefined && response.status === true) {
        arr = [];
        let rows = response.data.rows || [];
        if (rows.length !== 0) {
          for (let i = 0; i < rows.length; i++) {
            arr.push({
              mappedornot: rows[i].mappedornot,
              user_id: rows[i].user_id,
              first_name: rows[i].first_name,
              username: rows[i].username,
              gender: rows[i].gender,
              date_of_birth: rows[i].date_of_birth,
              mobile_no: rows[i].mobile_no,
              email_id: rows[i].email_id,
              school_name: rows[i].school_name,
              school_id: rows[i].school_id,
              school_funder: rows[i].school_funder,
              class_name: rows[i].class_name,
              class_id: rows[i].class,
              section: rows[i].section,
              check: false,
              radiouser: false,
              radioname: false,
              radiogender: false,
              radiodob: false,
              radiomob: false,
              radioemail: false,
              radiosch: false,
            });
          }
        }
        setFilterProduct(arr);
        setCurrentPage(page);
        setTotalPages(response.data.last_page || response.data.totalPages || 1);
        setTotalRecords(response.data.total || response.data.totalRecords || 0);
      }
      setLoading(false);
    });
  }

  let arr = [];
  const [schname, setSchName] = useState("");
  const [urllink, setUrlLink] = useState("");

  useEffect(() => {
    const url = window.location.href;
    const head = url.split("/#/");
    const link = head[1].split("/");
    setUrlLink(link[1]);
    if (localStorage.getItem("Role") === "1") {
      listall(1);
      schoollist().then((response) => {
        if (response !== undefined && response.status === true) {
          setSchoolListData(response.data.details || []);
        }
      });
      funderlist().then((response) => {
        if (response !== undefined && response.status === true) {
          setFunderListData(response.data.funders_list || []);
        }
      });
    } else if (localStorage.getItem("Role") === "3") {
      setLoading(true);
      // cityplayerlist(1, 6).then((response) => {
      //   if (response.status === true) {
      //     setFilterProduct(response.data);
      //     setLoading(false);
      //   }
      // });

      if (link[1] === "listplayers") {
        schoolwiseplayerlist(id, 1).then((response) => {
          if (response.status === true) {
            if (response.data.student_list.length !== 0) {
              setSchName(response.data.student_list[0].school_name);
            }
            setFilterProduct(response.data.student_list);
            setLoading(false);
          }
        });
      } else if (link[1] === "funderlistplayers") {
        schoolwiseplayerlist(id, 2).then((response) => {
          if (response.status === true) {
            if (response.data.student_list.length !== 0) {
              setSchName(response.data.student_list[0].school_funder);
            }
            setFilterProduct(response.data.student_list_for_funder);
            setLoading(false);
          }
        });
      }
    } else if (localStorage.getItem("Role") === "4") {
      setLoading(true);
      schoolplayerlist(7).then((response) => {
        if (response.status === true) {
          setFilterProduct(response.data);
          setLoading(false);
        }
      });
    } else if (localStorage.getItem("Role") === "7") {
      setLoading(true);
      coachplayerlist(7).then((response) => {
        if (response.status === true) {
          setFilterProduct(response.data);
          setLoading(false);
        }
      });
    }
  }, []);

  function backlist() {
    if (localStorage.getItem("Role") === "3") {
      if (urllink === "listplayers") {
        dotracking(
          "back button in player list for school " +
            schname +
            "  $$ " +
            trackobj.schoollistheading
        );
        navigate("/cityregional/schoollist");
      } else if (urllink === "funderlistplayers") {
        dotracking(
          "back button in player list for funder " +
            schname +
            "  $$ " +
            trackobj.schoollistheading
        );
        navigate("/cityregional/fundermanager");
      }
    } else if (localStorage.getItem("Role") === "4") {
      dotracking("back button in player list $$ " + trackobj.schoollistheading);
      navigate("/funder/schoollist");
    }
  }

  const [loading, setLoading] = useState(false);
  return (
    <Fragment>
      <div className="side-app">
        <div className="page-header">
          <div className="breadcrumb">
            <h4 className="mb-0">All Players</h4>
          </div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Players</a>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              All Players
            </li>
          </ol>
        </div>
        {loading && (
          <div className="dashloader-wrapper">
            <div className="loader"></div>
            <h3>Loading...Please do not go back or close the window.</h3>
          </div>
        )}
        {!loading && (
          <div className="row">
            <div className="col-12">
              <form className="card mt-0">
                <div className="card-body">
                {localStorage.getItem("Role") === "3" && (
                      <h4 className="text-center text-success">{schname}</h4>
                    )}

                    {localStorage.getItem("Role") === "1" &&
                      mdata.length === 2 && (
                        <div className="text-right mb-2">
                          <a
                            className="btn btn-success"
                            onClick={() => setMShow(true)}
                          >
                            Merge Data
                          </a>
                        </div>
                      )}
                    {(localStorage.getItem("Role") === "3" ||
                      localStorage.getItem("Role") === "8") && (
                      <div className="text-right mb-2">
                        <a className="btn btn-gray" onClick={backlist}>
                          Back
                        </a>
                      </div>
                    )}
                  {localStorage.getItem("Role") !== "3" &&
                      localStorage.getItem("Role") !== "4" &&
                      localStorage.getItem("Role") !== "8" && (
                        <>
                          <div className="row mb-2">
                            <div className="col-md-3">
                              <label className="form-label">Username</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Username"
                                value={fUsername}
                                onChange={(e) => setFUsername(e.target.value)}
                              />
                            </div>
                            <div className="col-md-3">
                              <label className="form-label">Full Name</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Full Name"
                                value={fFullName}
                                onChange={(e) => setFFullName(e.target.value)}
                              />
                            </div>
                            <div className="col-md-2">
                              <label className="form-label">Gender</label>
                              <select
                                className="form-control"
                                value={fGender}
                                onChange={(e) => setFGender(e.target.value)}
                              >
                                <option value="">All</option>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                              </select>
                            </div>
                            <div className="col-md-2">
                              <label className="form-label">DOB Year</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="e.g. 2007"
                                value={fDobYear}
                                onChange={(e) => setFDobYear(e.target.value)}
                              />
                            </div>
                            <div className="col-md-2">
                              <label className="form-label">Mobile</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Mobile"
                                value={fMobile}
                                onChange={(e) => setFMobile(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="row mb-2">
                            <div className="col-md-2">
                              <label className="form-label">Email</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Email"
                                value={fEmail}
                                onChange={(e) => setFEmail(e.target.value)}
                              />
                            </div>
                            <div className="col-md-3">
                              <label className="form-label">School</label>
                              <Select
                                isMulti
                                isClearable
                                placeholder="Select Schools..."
                                value={fSchoolIds}
                                onChange={(val) => setFSchoolIds(val || [])}
                                maxMenuHeight={200}
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "38px",
                                    maxHeight: "80px",
                                    overflowY: "auto",
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    maxHeight: "75px",
                                    overflowY: "auto",
                                  }),
                                }}
                                options={schoolListData.map((sch) => ({
                                  value: sch.id,
                                  label: sch.school_name,
                                }))}
                              />
                            </div>
                            <div className="col-md-3">
                              <label className="form-label">Funder</label>
                              <Select
                                isMulti
                                isClearable
                                placeholder="Select Funders..."
                                value={fFunderIds}
                                onChange={(val) => setFFunderIds(val || [])}
                                maxMenuHeight={200}
                                styles={{
                                  control: (base) => ({
                                    ...base,
                                    minHeight: "38px",
                                    maxHeight: "80px",
                                    overflowY: "auto",
                                  }),
                                  valueContainer: (base) => ({
                                    ...base,
                                    maxHeight: "75px",
                                    overflowY: "auto",
                                  }),
                                }}
                                options={funderListData.map((f) => ({
                                  value: f.id,
                                  label: f.funder_name,
                                }))}
                              />
                            </div>
                            <div className="col-md-2 d-flex align-items-end">
                              <a
                                className="btn btn-success me-2"
                                onClick={() => {
                                  setCurrentPage(1);
                                  listall(1);
                                }}
                              >
                                Search
                              </a>
                              <a
                                className="btn btn-gray"
                                onClick={() => {
                                  setFUsername("");
                                  setFFullName("");
                                  setFGender("");
                                  setFDobYear("");
                                  setFMobile("");
                                  setFEmail("");
                                  setFSchoolIds([]);
                                  setFFunderIds([]);
                                  setCurrentPage(1);
                                  listall(1, {
                                    username: "",
                                    full_name: "",
                                    gender: "",
                                    dob_year: "",
                                    mobile: "",
                                    email: "",
                                    school_ids: "",
                                    school_funder: "",
                                  });
                                }}
                              >
                                Clear
                              </a>
                            </div>
                            <div className="col-md-2 d-flex align-items-end justify-content-end">
                              <span>
                                Total Records: <b>{totalRecords}</b>
                              </span>
                            </div>
                          </div>
                        </>
                      )}

                  <div className="ag-theme-alpine ag-style">

                    {(localStorage.getItem("Role") === "3" ||
                      localStorage.getItem("Role") === "4" ||
                      localStorage.getItem("Role") === "8") && (
                      <AgGridReact
                        columnDefs={localStorage.getItem("Role") === "3" ? FcolumnDefs:ShcolumnDefs}
                        rowData={filterProduct}
                        pagination="true"
                        paginationPageSize="10"
                        sortingOrder={sorting}
                        suppressExcelExport={true}
                        suppressDragLeaveHidesColumns={true}
                      />
                    )}

                    {localStorage.getItem("Role") !== "3" &&
                      localStorage.getItem("Role") !== "4" &&
                      localStorage.getItem("Role") !== "8" && (
                        <AgGridReact
                          columnDefs={columnDefs}
                          rowData={filterProduct}
                          sortingOrder={sorting}
                          suppressExcelExport={true}
                          suppressDragLeaveHidesColumns={true}
                          suppressPaginationPanel={true}
                          onRowDoubleClicked={(e) => rowDoubleClicked(e)}
                        />
                      )}
                  </div>

                  {localStorage.getItem("Role") !== "3" &&
                    localStorage.getItem("Role") !== "4" &&
                    localStorage.getItem("Role") !== "8" && (
                      <div className="row mt-3 mb-3">
                        <div className="col-md-6">
                          <span>
                            Page <b>{currentPage}</b> of <b>{totalPages}</b> | Showing <b>{filterProduct.length}</b> of <b>{totalRecords}</b> records
                          </span>
                        </div>
                        <div className="col-md-6 text-right">
                          <a
                            className={`btn btn-secondary me-2 ${currentPage <= 1 ? "disabled" : ""}`}
                            onClick={() => {
                              if (currentPage > 1) {
                                listall(currentPage - 1);
                              }
                            }}
                          >
                            Previous
                          </a>
                          <a
                            className={`btn btn-success ${currentPage >= totalPages ? "disabled" : ""}`}
                            onClick={() => {
                              if (currentPage < totalPages) {
                                listall(currentPage + 1);
                              }
                            }}
                          >
                            Next
                          </a>
                        </div>
                      </div>
                    )}

                    <Modal show={mshow} size="xl">
                      <Modal.Header>
                        <h5>Merge Player Details</h5>
                        <i
                          className="fa fa-window-close fa-lg"
                          onClick={() => setMShow(false)}
                          aria-hidden="true"
                        ></i>
                      </Modal.Header>
                      <Modal.Body className="mod-body">
                        <div className="table-responsive mt-2">
                          <h5 className="text-success">
                            Select Username (UID) of main profile
                          </h5>
                          <Table bordered>
                            <tbody>
                              <tr>
                                <th>
                                  <b>Username (UID)</b>
                                </th>
                                {mdata.map((data, i) => {
                                  return (
                                    <td key={i}>
                                      {data.radiouser !== true && (
                                        <>
                                          <div
                                            style={{
                                              float: "left",
                                              width: "50%",
                                            }}
                                          >
                                            {data.username}
                                          </div>
                                          <div
                                            className="text-right"
                                            style={{
                                              float: "right",
                                              width: "50%",
                                            }}
                                          >
                                            <a
                                              className="btn btn-secondary"
                                              onClick={() =>
                                                mradiouser(data.user_id)
                                              }
                                            >
                                              Select if Main UID
                                            </a>
                                          </div>
                                        </>
                                      )}
                                      {data.radiouser === true && (
                                        <>
                                          <span className="font-weight-bold text-success">
                                            {data.username}
                                            <i className="fa fa-check ml-2"></i>
                                          </span>
                                        </>
                                      )}
                                    </td>
                                  );
                                })}
                              </tr>
                              <tr>
                                <th>
                                  <b>Fullname</b>
                                </th>
                                {mdata.map((data, i) => {
                                  return (
                                    <td key={i}>
                                      {data.radiouser === true && (
                                        <span className="font-weight-bold text-success">
                                          {data.first_name}
                                        </span>
                                      )}
                                      {data.radiouser !== true && (
                                        <>
                                          <input
                                            type="radio"
                                            className="me-2"
                                            checked={data.radioname}
                                            onClick={() =>
                                              mradioname(i, data.radioname)
                                            }
                                          />
                                          {data.first_name}
                                        </>
                                      )}
                                    </td>
                                  );
                                })}
                              </tr>
                              <tr>
                                <th>
                                  <b>Gender </b>
                                </th>
                                {mdata.map((data, i) => {
                                  return (
                                    <td key={i}>
                                      {data.radiouser === true && (
                                        <span className="font-weight-bold text-success">
                                          {data.gender}
                                        </span>
                                      )}
                                      {data.radiouser !== true && (
                                        <>
                                          <input
                                            type="radio"
                                            className="me-2"
                                            checked={data.radiogender}
                                            onClick={() =>
                                              mradiogender(i, data.radiogender)
                                            }
                                          />
                                          {data.gender}
                                        </>
                                      )}
                                    </td>
                                  );
                                })}
                              </tr>
                              <tr>
                                <th>
                                  <b>DOB</b>
                                </th>
                                {mdata.map((data, i) => {
                                  return (
                                    <td key={i}>
                                      {data.radiouser === true && (
                                        <span className="font-weight-bold text-success">
                                          {moment(data.date_of_birth).format(
                                            "DD-MM-yyyy"
                                          )}
                                        </span>
                                      )}
                                      {data.radiouser !== true && (
                                        <>
                                          <input
                                            type="radio"
                                            className="me-2"
                                            checked={data.radiodob}
                                            onClick={() =>
                                              mradiodob(i, data.radiodob)
                                            }
                                          />
                                          {moment(data.date_of_birth).format(
                                            "DD-MM-yyyy"
                                          )}
                                        </>
                                      )}
                                    </td>
                                  );
                                })}
                              </tr>
                              <tr>
                                <th>
                                  <b>Contact</b>
                                </th>
                                {mdata.map((data, i) => {
                                  return (
                                    <td key={i}>
                                      {data.radiouser === true && (
                                        <span className="font-weight-bold text-success">
                                          {data.mobile_no}
                                        </span>
                                      )}
                                      {data.radiouser !== true && (
                                        <>
                                          <input
                                            type="radio"
                                            className="me-2"
                                            checked={data.radiomob}
                                            onClick={() =>
                                              mradiomob(i, data.radiomob)
                                            }
                                          />
                                          {data.mobile_no}
                                        </>
                                      )}
                                    </td>
                                  );
                                })}
                              </tr>
                              <tr>
                                <th>
                                  <b>Email</b>
                                </th>
                                {mdata.map((data, i) => {
                                  return (
                                    <td key={i}>
                                      {data.radiouser === true && (
                                        <span className="font-weight-bold text-success">
                                          {data.email_id}
                                        </span>
                                      )}
                                      {data.radiouser !== true && (
                                        <>
                                          <input
                                            type="radio"
                                            className="me-2"
                                            checked={data.radioemail}
                                            onClick={() =>
                                              mradioemail(i, data.radioemail)
                                            }
                                          />
                                          {data.email_id}
                                        </>
                                      )}
                                    </td>
                                  );
                                })}
                              </tr>
                              <tr>
                                <th>
                                  <b>Class</b>
                                </th>
                                {mdata.map((data, i) => {
                                  return (
                                    <td key={i}>
                                      {data.radiouser === true && (
                                        <span className="font-weight-bold text-success">
                                          {data.class_name}
                                        </span>
                                      )}
                                      {data.radiouser !== true && (
                                        <>
                                          <input
                                            type="radio"
                                            className="me-2"
                                            checked={data.radiocls}
                                            onClick={() =>
                                              mradioclass(i, data.radiocls)
                                            }
                                          />
                                          {data.class_name}
                                        </>
                                      )}
                                    </td>
                                  );
                                })}
                              </tr>

                              <tr>
                                <th>
                                  <b>Section</b>
                                </th>
                                {mdata.map((data, i) => {
                                  return (
                                    <td key={i}>
                                      {data.radiouser === true && (
                                        <span className="font-weight-bold text-success">
                                          {data.section}
                                        </span>
                                      )}
                                      {data.radiouser !== true && (
                                        <>
                                          <input
                                            type="radio"
                                            className="me-2"
                                            checked={data.radiosec}
                                            onClick={() =>
                                              mradiosection(i, data.radiosec)
                                            }
                                          />
                                          {data.section}
                                        </>
                                      )}
                                    </td>
                                  );
                                })}
                              </tr>
                            </tbody>
                          </Table>
                          {errorMsg !== "" && (
                            <span className="errortext">{errorMsg}</span>
                          )}
                        </div>
                      </Modal.Body>
                      <Modal.Footer>
                        <button
                          className="btn btn-success"
                          onClick={() => setFShow(true)}
                        >
                          Merge Player
                        </button>
                        <button
                          onClick={() => setMShow(false)}
                          className="btn btn-gray"
                        >
                          Cancel
                        </button>
                      </Modal.Footer>
                    </Modal>

                    <Modal show={fshow} size="large">
                      <Modal.Header>
                        <h5>Merge Profile Confirmation</h5>
                        <i
                          className="fa fa-window-close fa-lg"
                          onClick={() => setFShow(false)}
                          aria-hidden="true"
                        ></i>
                      </Modal.Header>
                      <Modal.Body className="mod-body">
                        <div className="alignMe">
                          <h4 className="h4 mb-0 mt-3">
                            <b>Username (UID) </b>{" "}
                            <span className="font-weight-bold text-success">
                              {muname}
                            </span>
                          </h4>
                          <h4 className="h4 mb-0 mt-3">
                            <b>Fullname </b>{" "}
                            <span className="font-weight-bold text-success">
                              {mfname}
                            </span>
                          </h4>
                          <h4 className="h4 mb-0 mt-3">
                            <b>Gender </b>{" "}
                            <span className="font-weight-bold text-success">
                              {mgender}
                            </span>
                          </h4>
                          <h4 className="h4 mb-0 mt-3">
                            <b>DOB </b>{" "}
                            <span className="font-weight-bold text-success">
                              {moment(mdob).format("DD-MM-yyyy")}
                            </span>
                          </h4>
                          <h4 className="h4 mb-0 mt-3">
                            <b>Contact </b>{" "}
                            <span className="font-weight-bold text-success">
                              {mmob}
                            </span>
                          </h4>
                          <h4 className="h4 mb-0 mt-3">
                            <b>Email </b>{" "}
                            <span className="font-weight-bold text-success">
                              {memail}
                            </span>
                          </h4>
                          <h4 className="h4 mb-0 mt-3">
                            <b>Class </b>{" "}
                            <span className="font-weight-bold text-success">
                              {mclsname}
                            </span>
                          </h4>
                          <h4 className="h4 mb-0 mt-3">
                            <b>Section </b>{" "}
                            <span className="font-weight-bold text-success">
                              {msec}
                            </span>
                          </h4>
                        </div>

                        <br />
                      </Modal.Body>
                      <Modal.Footer>
                        <button
                          className="btn btn-secondary"
                          onClick={mergedprofiles}
                        >
                          Ok
                        </button>
                        <button
                          onClick={() => setFShow(false)}
                          className="btn btn-gray"
                        >
                          Cancel
                        </button>
                      </Modal.Footer>
                    </Modal>
                </div>
              </form>
            </div>
          </div>
        )}
      </div>
    </Fragment>
  );
};
